/**
 * Dealers that require DDC compliant button text
 *
 * Array of stripped down `.com` host names
 *
 * E.g. `www.bmowofeugene.com` becomes `bmwofeugeune`
 */
export const DDCCompliantDealers = [
  'audioakland',
  'audipaloalto',
  'bmwofeugene',
  'cmascolonialautocenter',
  'cmascolonialchevrolet',
  'cmascolonialhonda',
  'cmascolonialhyundai',
  'cmascolonialkia',
  'cmascolonialsubaru',
  'cmassubaruofwinchester',
  'cmasvalleycdjr',
  'cmasvalleyhonda',
  'cmasvalleynissan',
  'cmasvalleysubaru',
  'cmasvalleyvw',
  'epicfordeverett',
  'landroverboston',
  'medfordbmw',
  'scherervillemercedes',
  'volvocarsbellevue',
  'volvocarscharlottesville',
  'volvocarsseattle',
  'volvocarssouthwesthouston',
  'williamsburgford'
]

/**
 * Checks against a list of DDC dealers and returns compliant text if needed
 * @returns {String|undefined} DDC compliant text or undefined
 */
export const getCompliantText = () => {
  const shortHost = DDCCompliantDealers.find(
    shortHost => location.host.endsWith(`${shortHost}.com`)
  )
  if (!shortHost) return
  return 'See Car Info'
}
